export var livePreviewStyle = {
  border: '1px solid red',
  marginBottom: '10px'
};
export var isIE = typeof window !== 'undefined' && /MSIE|Trident/.test(window.navigator.userAgent);
export var supportsScopeQuery = function () {
  try {
    document.querySelector(':scope');
  } catch (_unused) {
    return false;
  }

  return true;
}();